import { Close as IconDeleteOption } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import { TextFieldElement } from "react-hook-form-mui";

import OptionVariantIndicator from "./OptionVariantIndicator";

type Props = {
    optionVariant: string;
    index: number;
    isLastItem: boolean;
    onRemove: () => void;
};

export default function SelectableQuestionOptionRow({ optionVariant, index, isLastItem, onRemove }: Props) {
    return (
        <>
            <OptionVariantIndicator optionVariant={optionVariant} index={index} />
            <TextFieldElement
                name={`options.${index}.name`}
                required
                size="small"
                fullWidth
                variant="standard"
                onFocus={e => {
                    e.target.select();
                }}
                sx={theme => ({
                    ".MuiInputBase-root.MuiInput-root:before": {
                        borderBottom: "none",
                    },
                    ".MuiInputBase-root.MuiInput-root:hover:before": {
                        borderBottom: `1px solid ${theme.palette.divider}`,
                    },
                })}
                slotProps={{
                    input: {
                        sx: theme => ({
                            fontSize: theme.typography.subtitle1.fontSize,
                            color: "text.primary",
                        }),
                    },
                }}
            />

            <IconButton onClick={onRemove} size="small" disabled={isLastItem}>
                <IconDeleteOption fontSize="small" />
            </IconButton>
        </>
    );
}
